import React, { Component } from 'react';
import { connect } from 'react-redux';

class Stats extends Component {
  render(){
    let padding = 0;
    return (
      <table className="white-text center" style={{tableLayout:"fixed",fontSize:"0.9em",height:'30px'}}>
        <tbody>
          <tr>
            <td style={{padding}}>24h High: {this.props.high}</td>
            <td style={{padding}}>24h Low: {this.props.low != Infinity ? this.props.low : ''}</td>
            <td style={{padding}}>24h Change: {this.props.change}</td>
            <td style={{padding}}>24h Volume:  {this.props.volume}</td>
          </tr>
        </tbody>
      </table>
    )
  }
}

function mapStateToProps(state,props) {
  let market = state.ui_marketplace.market;
  let high = '';
  let low = '';
  let change = '';
  let volume = '';
  let p = state.orderbook.stats[state.ui_marketplace.market.type][`${state.ui_marketplace.market.asset.toUpperCase()}/${state.ui_marketplace.market.denomination.toUpperCase()}`];
  high = p.high;
  low = p.low;
  volume = p.volume;
  change = p.lastPrice.price - p.firstPrice.price

  if(isNaN(high)) high = '';
  if(isNaN(low)) low = '';
  if(isNaN(volume) || volume === 0) volume = '';
  if(isNaN(change) || change === 0) change = '';
  return {
    high: high.toString().substring(0,10),
    low: low.toString().substring(0,10),
    change: change.toString().substring(0,10),
    volume: volume.toString().substring(0,12)
  };
}

export default connect(mapStateToProps,{})(Stats);
